"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const util_1 = require("../util");
const util_2 = require("./util");
function ProteinSequence({ cds, sequence, codonTable, }) {
    const str = (0, util_1.stitch)(cds, sequence);
    let protein = '';
    for (let i = 0; i < str.length; i += 3) {
        // use & symbol for undefined codon, or partial slice
        protein += codonTable[str.slice(i, i + 3)] || '&';
    }
    return react_1.default.createElement("span", { style: { background: util_2.proteinColor } }, protein);
}
exports.default = ProteinSequence;
